<div class="wrapper" [formGroup]="searchFilters">
    <div class="app-search-header-group-filter" *ngFor="let option of filterOption">
        <div class="app-search-header-group-filter-label">
            <label class="bold" [attr.aria-label]="option.displayName" style="display:inline;">
                <span>{{option.displayName==='Application ID'?'Quote Number':option.displayName}}</span>
            </label>
        </div>
        <div *ngIf="option.field_type === 'text'">
            <input #input autofocus [id]="option.id" [attr.aria-label]="" [type]="option.field_type"
                [formControlName]="option.code" [minlength]="option.min_length" [maxlength]="option.max_length"
                [pattern]="option.pattern" attr.data-cy="{{option.code}}">
        </div>
        <div class="app-search-header-group-filter-input" *ngIf="option.field_type === 'dropdown'">
            <mat-form-field type='dropdown' disableOptionCentering='true'>
                <mat-select hideSingleSelectionIndicator #input type="dropdown" [attr.id]="option.id" [id]="option.id" class="focusInput"
                    [formControlName]="option.code" attr.data-cy="{{option.code}}" placeholder="Select">
                    <mat-option *ngFor="let choice of option.choices" [value]="choice">{{ choice }}</mat-option>
                </mat-select>

                <mat-placeholder></mat-placeholder>
            </mat-form-field>
        </div>
    </div>
</div>
